import "./App.css";
import { Routes, Route } from "react-router-dom";
import React from "react";
import LandingPage from "./pages/landingPage";
import SelectedServicesComponent from "./components/ourServices/services";
import SingleCaseStudiesDetailsComponent from "./components/caseStudies/caseStudiesDetails";
import AboutUsComponent from "./components/aboutUs/aboutusComponent";
import "./styles/commonStyle.scss";
import BlogHomePage from "./components/blogs";
import BlogContentComponent from "./components/blogs/blogContent";

function App() {
  return (
    <div className="App">
      <React.Suspense>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route
            path="/services/:serviceName"
            element={<SelectedServicesComponent />}
          />
          <Route
            path="/casestudies/:caseStudies"
            element={<SingleCaseStudiesDetailsComponent />}
          />
          <Route path="/aboutUs" element={<AboutUsComponent />} />
          <Route path="/blog" element={<BlogHomePage />} />
          <Route path="/blog/:heading/:id" element={<BlogContentComponent />} />
        </Routes>
      </React.Suspense>
    </div>
  );
}

export default App;
